import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import CityPage from "@/pages/CityPage";
import InsurancePage from "@/pages/InsurancePage";
import CommercialPage from "@/pages/CommercialPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import RecentProjects from "@/pages/RecentProjects";
import LegalPage from "@/pages/LegalPage";
import { PRIVACY, TERMS } from "@/data/legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/roofing/:slug" element={<CityPage />} />
          <Route path="/insurance-roof-replacement" element={<InsurancePage />} />
          <Route path="/commercial-roofing" element={<CommercialPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/recent-projects" element={<RecentProjects />} />
          <Route path="/privacy-policy" element={<LegalPage doc={PRIVACY} />} />
          <Route path="/terms-and-conditions" element={<LegalPage doc={TERMS} />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </AuthProvider>
  );
}

export default App;
